import {
	CustomStringWidgetComponent,
	CustomIntegerWidgetComponent,
	CustomSelectWidgetComponent,
} from './components/widgets';
import { Injectable } from '@angular/core';
import { DefaultWidgetRegistry } from 'ngx-schema-form';

/** Custom widget registry to add custom widgets to ngx-schema-form */
// Not provided in root because this replaces the DefaultWidgetRegistry.
@Injectable({ providedIn: 'any' })
export class CustomWidgetRegistry extends DefaultWidgetRegistry {
	constructor() {
		super();
		this.register('string', CustomStringWidgetComponent);
		this.register('integer', CustomIntegerWidgetComponent);
		this.register('select', CustomSelectWidgetComponent);
	}
}
